import { AutoLogout } from '@backstage/core-components';
import { AppRootWrapperBlueprint } from '@backstage/plugin-app-react';

export const autoLogout = AppRootWrapperBlueprint.make({
  name: 'auto-logout',
  params: {
    component: ({ children }) => (
      <>
        <AutoLogout />
        {children}
      </>
    ),
  },
});
